import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import TW_log from '../machineUI/NaviBar/icons/travel-wifi-logo.png';
import AmericanExpress from '../Icons/payment/AmericanExpress.png';
import ApplePay from '../Icons/payment/ApplePay.png';
import DinersClub from '../Icons/payment/DinersClub.png';
import Discover from '../Icons/payment/Discover.png';
import GPay from '../Icons/payment/GPay.png';
import JCB from '../Icons/payment/JCB.png';
import Mastercard from '../Icons/payment/Mastercard.png';
import Visa from '../Icons/payment/Visa.png';
import Cookies from 'js-cookie';

import localRequest from '../services/LocalServer/localRequest';

export default function SelectPayment(props) {
  const [one, setone] = useState(true);
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const order_info = JSON.parse(localStorage.getItem('order_info'));
  let history = useHistory();
  const { t } = useTranslation();
  const machineID = props.id;

  let paymentMethod = 2;

  let separateItem = JSON.parse(localStorage.getItem('SeparateItem'));
  const mobile_pay = localStorage.getItem('MOBILE_PAY') === 'TRUE';
  const cash_pay = localStorage.getItem('CASH_PAY') === 'TRUE';

  const AE_PAY = localStorage.getItem('AE_PAY') === 'TRUE';
  const DC_PAY = localStorage.getItem('DC_PAY') === 'TRUE';
  const DIS_PAY = localStorage.getItem('DIS_PAY') === 'TRUE';
  const JCB_PAY = localStorage.getItem('JCB_PAY') === 'TRUE';

  const mycoockie = Cookies.get('i18next') ? Cookies.get('i18next') : 'en';

  let cashImage = mycoockie === 'es' ? `/Icons/${mycoockie}.png` : `/Icons/en.png`;

  if (mobile_pay) {
    paymentMethod++;
    paymentMethod++;
  }
  if (cash_pay) {
    paymentMethod++;
  }
  if (AE_PAY) {
    paymentMethod++;
  }
  if (DC_PAY) {
    paymentMethod++;
  }
  if (DIS_PAY) {
    paymentMethod++;
  }
  if (JCB_PAY) {
    paymentMethod++;
  }

  separateItem = separateItem.filter((e) => e.prodType === 'prod');

  const prods = separateItem.map((prod, i) => {
    // console.log(prod);
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  const cancelButton = async () => {
    if (one) {
      history.goBack();
      setone(false);
    }
  };

  const ccPage = async () => {
    await localRequest({
      method: 'post',
      url: '/updateKioskStatus',
      data: {
        status: 'OrderCreated',
        order_info: order_info,
      },
    }).then((res) => {
      history.push(`/machineUI/payment/${machineID}`);
    });
  };

  const cashPage = async () => {
    order_info.payment_type = 'CASH';
    await localRequest({
      method: 'post',
      url: '/updateKioskStatus',
      data: {
        status: 'OrderCreated',
        order_info: order_info,
      },
    }).then((res) => {
      history.push(`/machineUI/cashPayment/${machineID}`);
    });
  };

  return (
    <div className="payment-container">
      <div className="payment-container-div">
        <img className="payment-logo-img" src={TW_log} alt=""></img>
        <div className="payment-products-container">{prods}</div>
        <div className="payment-line"></div>
        <div className="payment-title">{t('Please select your payment method.')}</div>
        {paymentMethod > 8 ? (
          <div className="payment-list2">
            {cash_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={cashImage} onClick={cashPage} alt="" />
              </div>
            )}
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Visa} onClick={ccPage} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon2" src={Mastercard} onClick={ccPage} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={GPay} onClick={ccPage} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={ApplePay} onClick={ccPage} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={AmericanExpress} onClick={ccPage} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={DinersClub} onClick={ccPage} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={Discover} onClick={ccPage} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon2" src={JCB} onClick={ccPage} alt="" />
              </div>
            )}
          </div>
        ) : (
          <div className="payment-list">
            {cash_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={cashImage} onClick={cashPage} alt="" />
              </div>
            )}
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Visa} onClick={ccPage} alt="" />
            </div>
            <div className="payment-first-div">
              <img className="payment-visa-icon" src={Mastercard} onClick={ccPage} alt="" />
            </div>
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={GPay} onClick={ccPage} alt="" />
              </div>
            )}
            {mobile_pay && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={ApplePay} onClick={ccPage} alt="" />
              </div>
            )}
            {AE_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={AmericanExpress} onClick={ccPage} alt="" />
              </div>
            )}
            {DC_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={DinersClub} onClick={ccPage} alt="" />
              </div>
            )}
            {DIS_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={Discover} onClick={ccPage} alt="" />
              </div>
            )}
            {JCB_PAY && (
              <div className="payment-first-div">
                <img className="payment-visa-icon" src={JCB} onClick={ccPage} alt="" />
              </div>
            )}
          </div>
        )}

        <div className="view-more-button payment-cancel-button" onClick={cancelButton}>
          {t(`CANCEL`)}
        </div>
      </div>
    </div>
  );
}
